import {NavLink} from "react-router-dom";

export default function NavButton(props) {
    const baseStyle = "flex flex-col lg:flex-row items-center justify-center w-full rounded-lg font-bold p-4 gap-2 group hover:bg-white hover:text-dark-purple transition";
    return (
        <NavLink className={({isActive}) => isActive ? `${baseStyle} bg-white text-dark-purple ${props.extraStyle}` : `${baseStyle} bg-white/30 ${props.extraStyle}`} to={props.to} onClick={props.onClick}>
            {({isActive}) =>
                <>
                    <img className={isActive ? `hidden ${props.smallImage}` : `block group-hover:hidden ${props.smallImage}`} src={props.icon} alt={`Icon for ${props.label}`}/>
                    <img className={isActive ? `block ${props.smallImage}` : `hidden group-hover:block ${props.smallImage}`} src={props.activeIcon} alt={`Icon for ${props.label}`}/>
                    <span className={"block flex-grow text-sm lg:text-xl whitespace-nowrap text-left"}>{props.label}</span>
                </>
            }
        </NavLink>
    );
}
